export const CREATE_BUSINESS_UNIT_FORM_ID = 'create-business-unit-form';

export const CREATE_BUSINESS_UNIT_MODAL_TEST_ID =
  'developers_business_units_create';
export const CREATE_BUSINESS_UNIT_NAME_TEST_ID =
  'developers_business_units_create_name-input';
export const CREATE_BUSINESS_UNIT_SUBMIT_TEST_ID =
  'developers_business_units_create_submit-btn';
export const CREATE_BUSINESS_UNIT_CANCEL_TEST_ID =
  'developers_business_units_create_cancel-btn';

export const CREATE_BUSINESS_UNIT_TITLE = 'Create business unit';
export const CREATE_BUSINESS_UNIT_NAME_LABEL = 'Name';
export const CREATE_BUSINESS_UNIT_NAME_PLACEHOLDER = 'e.g. Acme EU';
export const CREATE_BUSINESS_UNIT_SUBMIT_LABEL = 'Create';
export const CREATE_BUSINESS_UNIT_CANCEL_LABEL = 'Cancel';

export const CREATE_BUSINESS_UNIT_SUCCESS = 'Business unit created';
export const CREATE_BUSINESS_UNIT_GENERIC_ERROR = 'Something went wrong';
